import { Select, type SelectProps } from 'antd';
import React, { useMemo } from 'react';

import { INTERNAL_ADMIN_ROLE_TO_LABEL, InternalAdminRole } from 'constants/internal-admin-roles';

type DefaultOptionType = NonNullable<SelectProps['options']>[number];

export function InternalAdminRoleSelect(props: SelectProps<InternalAdminRole>) {
  const internalAdminRoleOptions: DefaultOptionType[] = useMemo(
    () => Object.entries(INTERNAL_ADMIN_ROLE_TO_LABEL).map(([value, label]) => ({ label, value })),
    []
  );

  return (
    <Select<InternalAdminRole>
      options={internalAdminRoleOptions}
      {...props}
    />
  );
}